<template>
    <div>
        <v-alert dense border="bottom" type="primary" icon="mdi-information">
            PART RECOMMEND
        </v-alert>
        <div
            v-if="
                (condition.status == 'editcase' ||
                    condition.status == 'subcase') &&
                    condition.project == 'SRFR' &&
                    team_name != 'ODM'
            "
        >
            <v-chip
                v-for="(item, index) in partsrfr"
                :key="index"
                class="ma-2 ml-10"
                :color="item.color"
                outlined
                @click="genPartSrfr(item.name)"
            >
                <v-icon left>{{ item.icon }}</v-icon>
                {{ item.name }}
            </v-chip>
        </div>
        <!-- v-if="(condition.status == 'editcase' ||condition.status == 'subcase') &&condition.project == 'SRFR' &&team_name == 'ODM'" -->
        <div
            v-if="
                (condition.status == 'editcase' ||
                    condition.status == 'subcase') &&
                    team_name == 'ODM'
            "
        >
            <v-chip
                v-for="(item, index) in partsrfrodm"
                :key="index"
                class="ma-2 ml-10"
                :color="item.color"
                outlined
                @click="genPartSrfr(item.name)"
            >
                <v-icon left>{{ item.icon }}</v-icon>
                {{ item.name }}
            </v-chip>
        </div>
        <v-card-text>
            <v-container fluid>
                <v-row v-for="(row, index) in information.part" :key="index">
                    <v-col cols="12" class="mb-3"
                        ><span class="font-b"
                            >LineNumber : {{ row.ponumber_line }}</span
                        >
                        <span
                            class="font-b ml-2 mr-2 primary--text"
                            v-if="row.subcase"
                            >{{ "SUB - " + row.subcase }}</span
                        >
                        <span class="font-b red--text" v-if="row.rf_name">{{
                            row.rf_name
                        }}</span>
                    </v-col>
                    <v-col cols="6" md="2" class="mar-t-25">
                        <v-text-field
                            dense
                            outlined
                            label="PO Number / Enter"
                            class="caption"
                            v-on:keyup.enter="checkPO_new(row.ponumber, index)"
                            v-model="row.ponumber"
                        ></v-text-field>
                        <!-- checkPO_new(row.ponumber, row, index) -->
                    </v-col>
                    <v-col cols="6" md="2" class="mar-t-25">
                        <v-text-field
                            dense
                            outlined
                            label="Part NO"
                            class="caption"
                            v-model="row.part_no"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" md="2" class="mar-t-25">
                        <v-text-field
                            dense
                            outlined
                            label="Part Description"
                            class="caption"
                            v-model="row.part_desc"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" md="2" class="mar-t-25">
                        <v-text-field
                            dense
                            outlined
                            label="RMA"
                            class="caption"
                            v-model="row.rma"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" md="2" class="mar-t-25">
                        <v-select
                            height="30"
                            @change="changeStaPart(index)"
                            :items="statuspart"
                            v-model="row.status"
                            label="Status"
                            outlined
                            dense
                        ></v-select>
                    </v-col>
                    <v-col cols="6" md="2" class="mar-t-25">
                        <td>
                            <v-text-field
                                dense
                                outlined
                                label="Remark"
                                class="caption"
                                v-model="row.remark"
                            ></v-text-field>
                        </td>
                    </v-col>
                    <v-col cols="6" md="2" class="mar-t-25">
                        <v-text-field
                            dense
                            outlined
                            label="Eta"
                            class="caption"
                            v-model="row.eta"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="6"
                        md="2"
                        class="mar-t-25"
                        v-if="condition.status == 'editcase'"
                    >
                        <v-select
                            :items="partstatus"
                            v-model="row.ce_status"
                            label="สถานะ part"
                            dense
                            outlined
                        ></v-select>
                    </v-col>
                    <v-col cols="6" md="2" class="mar-t-25">
                        <td>
                            <v-menu
                                v-model="row.modal"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="row.extended_date"
                                        label="Extended date"
                                        prepend-icon=""
                                        dense
                                        outlined
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="row.extended_date"
                                    no-title
                                    @input="row.modal = false"
                                ></v-date-picker>
                            </v-menu>
                        </td>
                    </v-col>
                    <v-col cols="6" md="2" class="mar-t-25">
                        <v-checkbox
                            style="margin-top: 0px"
                            true-value="Y"
                            false-value="N"
                            v-model="row.required_uefi"
                            label="Required UEFI"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="6" md="2" class="mar-t-25">
                        <span
                            v-if="
                                (row.part_no != '' &&
                                    index == information.part.length - 1) ||
                                    condition.team == 'ODM'
                            "
                        >
                            <v-btn
                                x-small
                                @click="addpart()"
                                color="amber"
                                fab
                                small
                            >
                                <v-icon color="white">mdi-plus</v-icon>
                            </v-btn>
                        </span>
                        <span v-if="information.part.length >= 1">
                            <v-btn
                                class="ml-2"
                                x-small
                                @click="delpart(index)"
                                color="red accent-2"
                                fab
                                small
                            >
                                <v-icon color="white">mdi-delete</v-icon>
                            </v-btn>
                        </span>

                        <!-- <v-row>
                            <v-col :cols="6"> </v-col>
                            <v-col :cols="6"> </v-col>
                        </v-row> -->
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>
<script>
import axios from "axios"
import _ from "lodash"

export default {
    props: ["information", "condition"],
    mounted() {
        this.getPart()
    },
    data() {
        return {
            team_name: localStorage.team_name,
            modal: [],
            date_min: null,
            check: true,
            partstatus: ["Good", "Bad", "Pending", "Same Item", "DOA"],
            partsrfr: [
                {
                    name: "M0H50 Color",
                    color: "blue accent-4",
                    icon: "",
                },
                {
                    name: "M0H51 Black",
                    color: "#000000",
                    icon: "",
                },
                {
                    name: "X4E75 Black",
                    color: "#212121",
                    icon: "",
                },
                {
                    name: "3YP17A Color",
                    color: "blue accent-4",
                    icon: "",
                },
            ],
            partsrfrodm: [
                {
                    name: "M0H50 Color",
                    color: "blue accent-4",
                    icon: "",
                },
                {
                    name: "M0H51 Black",
                    color: "#000000",
                    icon: "",
                },
                {
                    name: "X4E75 Black",
                    color: "#212121",
                    icon: "",
                },
                {
                    name: "W1104A Black",
                    color: "#212121",
                    icon: "",
                },
                {
                    name: "3YP17A Color",
                    color: "blue accent-4",
                    icon: "",
                },
            ],
            statuspart: ["Recommend", "Ship", "Back Order", "onhand", "return"],
            partShow: [],
            part: {
                part_issue_id: "",
                ponumber: "",
                part_no: "",
                part_desc: "",
                rma: "",
                dateorder: "",
                dateship: "",
                status: "",
                remark: "",
                ce_status: "",
                extended_date: "",
                rf_name: "",
                subcase: "",
                required_uefi: "",
                ponumber_line: null,
                eta: null,
            },

            headers: [
                {
                    text: "PO NUMBER",
                    value: "ponumber",
                    class: "text-uppercase darken-3 black--text caption",
                },
                {
                    text: "PART NO",
                    value: "part_no",
                    class: "text-uppercase darken-3 black--text caption",
                },
                {
                    text: "DESCRIPTION",
                    value: "part_desc",
                    class: "text-uppercase darken-3 black--text caption",
                },
                {
                    text: "RMA",
                    value: "rma",
                    class: "text-uppercase darken-3 black--text caption",
                },
                {
                    text: "STATUS",
                    value: "status",
                    class: "text-uppercase darken-3 black--text caption",
                },
                {
                    text: "REMARK",
                    value: "remark",
                    class: "text-uppercase darken-3 black--text caption",
                },
                {
                    text: "Required uefi",
                    value: "required_uefi",
                    class: "text-uppercase darken-3 black--text caption",
                },
                {
                    text: "ETA",
                    value: "eta",
                    class: "text-uppercase darken-3 black--text caption",
                },
                {
                    text: "",
                    value: "action",
                    class: "text-uppercase darken-3 black--text caption",
                    sortable: false,
                },
            ],
        }
    },
    methods: {
        genPartSrfr(item) {
            if (
                this.information.part[0].part_no === undefined ||
                this.information.part[0].part_no == ""
            ) {
                this.information.part.splice(0, 1)
                this.partShow.splice(0, 1)
            }
            this.partShow = [...this.information.part]
            this.information.part = []
            if (item != "W1104A Black") {
                this.partShow.push({
                    part_issue_id: "",
                    ponumber: "",
                    part_no: item,
                    part_desc: "printhead",
                    rma: "",
                    dateorder: "",
                    dateship: "",
                    status: "Recommend",
                    remark: "",
                    ponumber_line: "",
                })
            } else {
                this.partShow.push({
                    part_issue_id: "",
                    ponumber: "",
                    part_no: item,
                    part_desc: "Drum HP 104A Black",
                    rma: "",
                    dateorder: "",
                    dateship: "",
                    status: "Recommend",
                    remark: "",
                    ponumber_line: "",
                })
            }
            this.information.part = [...this.partShow]
            this.partShow = []
            console.log(this.information.part)
        },
        async changeStaPart(index) {
            if (
                this.information.part[index].part_issue_id != "" &&
                this.information.part[index].part_issue_id !== undefined
            ) {
                const url = `${process.env.VUE_APP_ROOT_API}/api/edit-part/${this.information.part[index].part_issue_id}`
                const body = {
                    part_status: this.information.part[index].status,
                }
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }
                const { data } = await axios.post(url, body, options)
            }
        },
        async checkPO_new(ponumber, index) {
            if (
                (ponumber[0] == "P" || ponumber[0] == "M") &&
                ponumber.length == "12"
            ) {
                console.log("test mo")
                const url = `${process.env.VUE_APP_ROOT_API}/api/hp/check-po-number`
                const body = {
                    po_number: ponumber,
                }
                await axios
                    .post(url, body)
                    .then((response) => {
                        console.log(response.data, "-response checkPO_new")
                        if (response.data.status == "success") {
                            if (index == 0) {
                                this.information.part = []
                            }
                            response.data.message.map((el, ii) => {
                                console.log(el, "-el")
                                el.status =
                                    el.atpstatus == "BACKORDER"
                                        ? "Back Order"
                                        : "Ship"
                                if (index == 0) {
                                    console.log("--if")
                                    this.information.part.push(el)
                                } else {
                                    console.log("--else")
                                    console.log(
                                        this.information.part,
                                        "-this.information.part"
                                    )

                                    const found = this.information.part.some(
                                        (r) => r.rma === el.rma
                                    )
                                    console.log(found, "-found")
                                    if (found == false) {
                                        // if (found == true) {
                                        //edit 12/10/23
                                        this.information.part = this.information.part.filter(
                                            (item) => item.part_no != ""
                                        )

                                        console.log(el, "-el -2")
                                        this.information.part.push(el)
                                    }
                                }
                            })
                        } else {
                            swal({
                                title: "Error",
                                text: response.data.message,
                                icon: "error",
                                timer: 1500,
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else {
                this.$swal("POnumber ไม่ถูกต้องโปรดแก้ไข", {
                    icon: "warning",
                    button: false,
                    timer: 1500,
                })
            }
        },
        async checkPO(ponumber, items, index) {
            this.check = true
            // alert(ponumber);

            if (index == 0 && items.part_no != "") {
                this.check = false
            }

            for (let a = 0; a < this.information.part.length - 1; a++) {
                if (this.information.part[a].part_no == "") {
                    this.check = true
                    break
                }
                if (this.information.part[a].ponumber == ponumber) {
                    this.check = false
                    exit()
                }
                if (
                    this.information.part[this.information.part.length - 1]
                        .ponumber == this.information.part[a].ponumber ||
                    this.information.part[this.information.part.length - 1]
                        .part_no != ""
                ) {
                    this.check = false
                    exit()
                }
            }

            // for (let a = 0; a < this.information.part.length; a++) {
            //   if (
            //     this.information.part[this.information.part.length - 1].ponumber ==
            //     this.information.part[a].ponumber
            //   ) {
            //     alert(this.check);
            //     // this.check = false;
            //   }
            // }

            if (this.check != false) {
                if (ponumber[0] == "P" && ponumber.length == "12") {
                    const url = `${process.env.VUE_APP_ROOT_API}/api/hp/check-po-number`
                    const body = {
                        po_number: ponumber,
                    }
                    try {
                        const { data } = await axios.post(url, body)

                        if (data.status != "success") {
                            swal({
                                title: "Error",
                                text: data.message,
                                icon: "error",
                                timer: 1500,
                            })
                        } else {
                            if (
                                this.information.part[0].part_no ===
                                    undefined ||
                                this.information.part[0].part_no == ""
                            ) {
                                this.information.part.splice(0, 1)
                                this.partShow.splice(0, 1)
                            }
                            data.message.map((each) => {
                                this.partShow.push({
                                    part_issue_id:
                                        each.part_issue_id != undefined
                                            ? each.part_issue_id
                                            : "",
                                    ponumber: each.ponumber,

                                    part_no:
                                        each.offer_part_no != "" &&
                                        each.offer_part_no != null
                                            ? each.offer_part_no
                                            : each.part_no,
                                    part_desc:
                                        each.offer_part_desc != "" &&
                                        each.offer_part_desc != null
                                            ? each.offer_part_desc
                                            : each.part_desc,
                                    // part_no: each.part_no,
                                    // part_desc: part_desc,
                                    // part_no:
                                    //     each.part_no != "" &&
                                    //     each.part_no != null &&
                                    //     each.part_no != undefined
                                    //         ? each.part_no
                                    //         : each.offer_part_no,
                                    // part_desc:
                                    //     each.part_desc != "" &&
                                    //     each.part_desc != null &&
                                    //     each.part_desc != undefined
                                    //         ? each.part_desc
                                    //         : each.offer_part_desc,
                                    rma: each.rma,
                                    dateorder: each.dateorder,
                                    dateship: each.dateship,
                                    status:
                                        each.atpstatus == "BACKORDER"
                                            ? "Back Order"
                                            : "Ship",
                                    remark: each.atpstatus,
                                    ce_status: "",
                                    ponumber_line: each.ponumber_line,
                                })
                            })
                            this.information.part.splice(
                                this.information.part.length - 1,
                                1
                            )
                            this.information.part = [
                                ...this.information.part,
                                ...this.partShow,
                            ]
                            this.partShow = []
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    this.$swal("POnumber ไม่ถูกต้องโปรดแก้ไข", {
                        icon: "warning",
                        button: false,
                        timer: 1500,
                    })
                }
            }
        },
        getPart() {
            // console.log(this.information, "-information")

            this.information.part.map((each) => {
                console.log(each, "-each")
                let XPart
                if (each.atpstatus == "BACKORDER") {
                    XPart = "Back Order"
                } else {
                    // HYBRID
                    // Recommend
                    // Ship
                    // onhand
                    // Return

                    // CDAX
                    // 100000000,None
                    // 100000001,Ordered
                    // 100000002,Available
                    // 100000003,Closed --
                    // 100000004,Cancelled --
                    // 100000005,Order Pending
                    // 100000006,Partial Ordered
                    // 100000007,Non Available
                    // 100000008,Partial Available
                    // 100000009,Issued
                    // 100000010,Recommended
                    // 100000012,Back Ordered
                    // 100000011,Shipped
                    if (
                        each.part_status == "100000011" ||
                        each.part_status == "100000009"
                    ) {
                        XPart = "Shipped"
                    } else {
                        XPart = "Back Order"
                    }
                }
                // console.log(each.part_status)
                this.partShow.push({
                    extended_date: "",
                    modal: false,
                    part_issue_id: each.part_issue_id,
                    ponumber: each.ponumber,
                    part_no:
                        each.offer_part_no != "" &&
                        each.offer_part_no != undefined
                            ? each.offer_part_no
                            : each.part_no,
                    part_desc:
                        each.offer_part_desc != "" &&
                        each.offer_part_desc != undefined
                            ? each.offer_part_desc
                            : each.part_desc,
                    // part_no: each.part_no,
                    // part_desc: each.part_desc,
                    // part_no:
                    //     each.part_no != "" && each.part_no != undefined
                    //         ? each.part_no
                    //         : each.offer_part_no,
                    // part_desc:
                    //     each.part_desc != "" && each.part_desc != undefined
                    //         ? each.part_desc
                    //         : each.offer_part_desc,
                    rma: each.rma,
                    dateorder: each.dateorder,
                    dateship: each.dateship,
                    status:
                        each.atpstatus == "BACKORDER" ? "Back Order" : "Ship",
                    // status: XPart,
                    remark: each.atpstatus,
                    required_uefi: each.required_uefi,
                    ponumber_line: each.ponumber_line,
                })
                console.log(this.partShow)
            })

            if (
                this.information.part.length == 0 ||
                this.information.part === undefined
            ) {
                this.partShow.push({
                    extended_date: "",
                    modal: false,
                    part_issue_id: "",
                    ponumber: "",
                    part_no: "",
                    part_desc: "",
                    rma: "",
                    dateorder: "",
                    dateship: "",
                    status: "",
                    remark: "",
                    ponumber_line: "",
                })
            }

            this.information.part = [...this.partShow]
        },
        async delpart(index) {
            if (
                this.information.part[index].part_issue_id == "" ||
                this.information.part[index].part_issue_id === undefined
            ) {
                this.information.part.splice(index, 1)
                this.partShow.splice(index, 1)
            } else {
                const url = `${process.env.VUE_APP_ROOT_API}/api/delete-part/${this.information.part[index].part_issue_id}`
                const { data } = await axios.delete(url)
                if (data == "delete - complete") {
                    this.information.part.splice(index, 1)
                    this.partShow.splice(index, 1)
                }
            }
            if (this.information.part.length == 0) {
                this.partShow.push({
                    part_issue_id: "",
                    ponumber: "",
                    part_no: "",
                    part_desc: "",
                    rma: "",
                    dateorder: "",
                    dateship: "",
                    status: "",
                    remark: "",
                    ponumber_line: "",
                })
                this.information.part = [...this.partShow]
            }
            // console.log(this.information, "del")
        },
        addpart() {
            this.information.part.push({ ...this.part })
        },
    },
}
</script>
